import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import { getFormatDate, getShortId } from '@/utils/format-strings'
import copyTextMixin from '@/components/mixins/copy-text-mixin'
import scrollToOrderTable from '@/components/mixins/scroll-to-order-table'
import sortFieldTable from '@/components/mixins/sort-field-table'
import Loader from '@/components/loader/loader.vue'
import IcBicycle from '@/assets/svg/ic_bicycle.svg?inline'
import IcBicycleRed from '@/assets/svg/ic_bicycle-red.svg?inline'
import IcCar from '@/assets/svg/ic-car.svg?inline'
import IcCarRed from '@/assets/svg/ic-car-red.svg?inline'
import { saveManufactureLocStorage } from '@/store/manufactures'
import { getOrderIdTdClass } from '@/utils/getOrderIdTdClass'

export default {
  name: 'RegionOrdersTable',
  /**
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [copyTextMixin, scrollToOrderTable, sortFieldTable],
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    sortFields: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TableCustomSort,
    Loader,
    IcCar,
    IcCarRed,
    IcBicycle,
    IcBicycleRed
  },
  data() {
    return {
      table: {
        columns: [
          {
            label: '№ заказа',
            field: 'order_id',
            thClass: 'order-id-td',
            tdClass: getOrderIdTdClass,
            sortable: false
          },
          {
            label: 'Статус',
            field: 'status',
            tdClass: 'status-td',
            sortable: false
          },
          {
            label: 'Производство',
            field: 'manufacture.title',
            tdClass: 'manufacture-td',
            sortable: false
          },
          {
            label: 'Адрес',
            field: 'address.full_address',
            sortable: false,
            tdClass: row => {
              return `address-td status-order-color__${row.status}--opacity`
            }
          },
          {
            label: 'Доставить',
            field: 'datetime_delivery_date',
            tdClass: 'delivery-td',
            sortable: false
          },
          {
            label: 'На кухне',
            field: 'time_in_cooking',
            width: '90px',
            sortable: false
          },
          {
            label: 'Маршрут',
            field: 'route_task.route_task_id',
            type: 'number',
            sortable: false
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      regionOrdersFilters: state => state.regionOrders.regionOrdersFilters,
      orderStatuses: state => state.sharedData.orderStatuses
    }),
    ...mapGetters({
      isAutoRouteTaskActive: 'logistics/isAutoRouteTaskActive' // Теперь это вычисляемое свойство
    })
  },
  mounted() {
    this.vgtResponsiveEl = this.$refs.table.$el.querySelector('.vgt-responsive')
    if (this.vgtResponsiveEl) {
      this.vgtResponsiveEl.addEventListener('scroll', this.onScrollTable)
    }
  },
  methods: {
    ...mapActions({
      getRouteTaskById: 'routeTasks/getRouteTaskById'
    }),

    ...mapMutations({
      setRegionOrdersFilters: 'regionOrders/SET_REGION_ORDERS_FILTERS',
      setEditedRouteTask: 'routeTasks/SET_EDITED_ROUTE_TASK',
      setEditedRouteTaskInfo: 'routeTasks/SET_EDITED_ROUTE_TASK_INFO',
      setSelectedManufacture: 'manufactures/SET_SELECTED_MANUFACTURE'
    }),

    getFormatDate,
    getShortId,

    getRoutTaskText(order, isShort = false) {
      return `м 
        ${
          isShort ? this.getShortId(order.route_task.route_task_id) : order.route_task.route_task_id
        }${order.route_task.allowed_by_foot_courier ? ' (в)' : ''}`
    },
    selectRouteTask(event, order) {
      if (this.isShiftPress) {
        this.onCopyText(event, this.getRoutTaskText(order))
        return
      }
      this.setSelectedManufacture(order.manufacture)
      this.getRouteTaskById(order.route_task.route_task_id)
    },
    openAddressMap(order) {
      this.setSelectedManufacture(order.manufacture)
      if (order.route_task) {
        this.getRouteTaskById(order.route_task.route_task_id)
      } else if (order.may_be_included_in_route_task) {
        this.setEditedRouteTask([order])
        this.setEditedRouteTaskInfo(null)
      }
    },
    /**
     *
     * @param {{ field: string, type: 'asc' : 'desc' }[]} params
     */
    onSortChange(params) {
      const sortObj = params[0]
      const filedName = `${sortObj.type === 'desc' ? '-' : ''}${sortObj.field
        .split('.')
        .join('__')}`
      this.setRegionOrdersFilters({
        ...this.regionOrdersFilters,
        offset: 0,
        sort: filedName
      })
    },
    onScrollTable(event) {
      const { offsetHeight, scrollTop, scrollHeight } = event.target
      if (offsetHeight + scrollTop >= scrollHeight) {
        this.onScrollEndTable()
      }
    },
    onScrollEndTable() {
      if (this.orders.length < this.count) {
        this.setRegionOrdersFilters({
          ...this.regionOrdersFilters,
          offset: this.regionOrdersFilters.offset + this.regionOrdersFilters.limit
        })
      }
    },
    onGoManufacture(manufacture) {
      this.setSelectedManufacture(manufacture)
    },
    onClickOrderId(event, order) {
      if (this.isShiftPress) {
        this.onCopyText(event, order.order_id)
        return
      }
      this.setSelectedManufacture(order.manufacture)
      this.$router.push({
        name: 'order-detail',
        params: {
          id: order.order_id
        }
      })
    },
    onContextmenuOrder(order) {
      saveManufactureLocStorage(order.manufacture)
    }
  },
  watch: {
    orders() {
      this.$nextTick(() => {
        if (this.vgtResponsiveEl) {
          if (
            this.vgtResponsiveEl.scrollHeight <= this.vgtResponsiveEl.clientHeight &&
            !this.regionOrdersLoading
          ) {
            this.onScrollEndTable()
          }
        }
      })
    }
  }
}
